import React, {Component} from 'react';
import braintree from 'braintree-web-drop-in';
import axios from 'axios';

export class PayBtn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSubmit: this.props.showSubmit,
      paymentResponse: null,
    };
  }

  async componentDidMount() {
    const response = await axios.get(
      'https://agile-ocean-79433.fly.dev/pay/get-token'
    );
    const authorization = await response.data.paymentToken;
    braintree.create(
      {
        authorization,
        selector: '#dropin-container',
        paypal: {
          amount: 20,
          currency: 'USD',
          flow: 'checkout',
          buttonStyle: {
            color: 'blue',
            shape: 'rect',
            size: 'medium',
          },
        },
      },
      (err, instance) => {
        if (err) console.log('ERROR!', err);
        const button = document.querySelector('#postNonce');
        if (button) {
          button.addEventListener('click', () => {
            instance.requestPaymentMethod((err, payload) => {
              if (err) {
                console.log('code 31', err);
              }
              if (payload) {
                const {nonce} = payload;
                console.log('nonce', nonce);
                this.props.nonceHandler(nonce);
              }
            });
          });
        }
      }
    );
  }

  render() {
    console.log(this.props.priceToPay);
    return (
      <div>
        <div id="dropin-container" />
        {this.props.showSubmit && (
          <button className="btn btn-success" id="postNonce">
            SUBMIT CARD INFORMATION
          </button>
        )}
        {this.state.paymentResponse && <h1>{this.state.paymentResponse}</h1>}
      </div>
    );
  }
}

export default PayBtn;



// WEBPACK FOOTER //
// ./src/components/PayBtn.js